import React from 'react';
import {connect} from 'react-redux';
import * as PIXI from 'pixi.js';
import cortina_ske from '../resource/burbujas/burbujas-2_ske.json';
import cortina_tex from '../resource/burbujas/burbujas-2_tex.json';
import cortina_png from '../resource/burbujas/burbujas-2_tex.png';
import dragonBones from '../dragonBones';
import transitionController from '../transitionController';

const COVER = 'animation1';
const REVEAL = 'Animation2';
// ponytail: safety net only — if the COMPLETE event never fires we still resolve.
const FALLBACK_MS = 8000;

// Decode starts at bundle eval so the first curtain has zero load hitch.
const curtainTexture = PIXI.Texture.fromImage(cortina_png);

let curtainParsed = false;

class Transition extends React.Component {
    componentDidMount() {
        const factory = dragonBones.PixiFactory.factory;
        if (!curtainParsed) {
            factory.parseDragonBonesData(cortina_ske);
            factory.parseTextureAtlasData(cortina_tex, curtainTexture);
            curtainParsed = true;
        }

        this.playing = false;
        this.armature = factory.buildArmatureDisplay('Armature', 'burbujas-2');
        this.armature.x = 960;
        this.armature.y = 550;
        this.armature.scale.set(1.2);
        this.armature.visible = false;
        this.props.app.stage.addChild(this.armature);

        transitionController.setPlayer({
            cover: () => this.play(COVER, 1.2),
            reveal: () => this.play(REVEAL, 0.9),
        });

        if (this.props.transition) {
            transitionController.cover();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (!this.armature) return;
        this.armature.visible = nextProps.transition || this.playing;
        if (nextProps.transition && !this.props.transition) {
            transitionController.cover();
        }
    }

    componentWillUnmount() {
        transitionController.setPlayer(null);
        if (this.armature) {
            this.armature.dispose(); // unregister from the DragonBones WorldClock
            this.armature = null;
        }
    }

    play(animationName, timeScale) {
        return new Promise((resolve) => {
            this.playing = true;
            const animation = this.armature.animation;
            const config = animation.animationConfig;
            config.name = animationName;
            config.animation = animationName;
            config.playTimes = 1;
            config.timeScale = timeScale;
            config.duration = 3.0;

            let finished = false;
            const finish = () => {
                if (finished) return;
                finished = true;
                clearTimeout(fallback);
                this.armature.removeDBEventListener(dragonBones.EventObject.COMPLETE, onComplete, this);
                this.playing = false;
                this.armature.visible = this.props.transition;
                resolve();
            };
            const onComplete = () => finish();
            const fallback = setTimeout(finish, FALLBACK_MS);

            this.armature.addDBEventListener(dragonBones.EventObject.COMPLETE, onComplete, this);
            this.armature.visible = true;
            animation.playConfig(config);
        });
    }

    render() {
        return null;
    }
}

const mapStateToProps = (state) => ({
    transition: state.transition,
});

export default connect(mapStateToProps)(Transition);



// WEBPACK FOOTER //
// ./src/components/Transition.js